import { IMAGE_ANALYSIS_API, ImageAnalysisResultContent } from '@aloft/toolkit-shared';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import {
  PostImageAnalysisError,
  PostImageAnalysisVariables,
  fetchPostImageAnalysis,
} from '../toolkitComponents.ts';
import { useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = IMAGE_ANALYSIS_API.POST;

/** @deprecated - Delete once ImageAnalysisDemoRouteElement is replaced */
export const usePostImageAnalysis = (
  options?: Omit<
    UseMutationOptions<
      { content: ImageAnalysisResultContent },
      PostImageAnalysisError,
      PostImageAnalysisVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<
    { content: ImageAnalysisResultContent },
    PostImageAnalysisError,
    PostImageAnalysisVariables
  >({
    mutationFn: (variables: PostImageAnalysisVariables) =>
      fetchPostImageAnalysis({
        ...fetcherOptions,
        ...variables,
        body: API_SCHEMA.REQUEST.BODY.parse(variables.body),
      }).then((r) => API_SCHEMA.RESPONSE.parse(r)),
    ...options,
  });
};
